import React from 'react'
import { Box, Typography } from '@material-ui/core'
import DownloadIcon from '@material-ui/icons/GetApp'

const style = {
  backgroundColor: '#',
  borderRadius: '3px'
}

export default function TextInfoDisplay (props) {
  if (!props.children) return null

  return <Box style={{ marginBottom: '10px' }}>
    <a href={props.href} style={{
      textDecoration: 'none'
    }}>
      <Typography>
        {props.children}
      </Typography>
      <DownloadIcon />
    </a>
  </Box>
}